import BrowserHelper from "./Browser";

export default class AnimationHelper {
	static toggleBox(el) {
		return new Promise((resolve, reject) => {
			if( !el.hasClass('blb-box') ) return reject(new Error('Element is not of class .blb-box.'));

			let c = el.find('.blb-box-content').first();

			// Abort any previous animations
			el.finish();

			if( !el.hasClass('skip-animation') ) {
				c.on('transitionend', function(e) {
					$(e.target).off('transitionend');

					if( el.hasClass('collapsed') ) { $(e.target).css('max-height', '') } else {
						$(e.target).css('max-height', 'min-content');
					}

					resolve();
				});

				c.css('max-height', c[0].scrollHeight).promise().then(function() {
					el.toggleClass('collapsed')
				});
			}
			else {
				el.toggleClass('collapsed');
				resolve();
			}
		});
	}

	// General animation for elements
	static toggle(el, cl = 'hidden') {
		return new Promise((resolve, reject) => {
			el.finish();

			el.on('transitionend', (e) => {
				el.off('transitionend');
				el.css('max-height', '');
				resolve();
			});

			el.css('max-height', el[0].scrollHeight).promise().then(function() {
				el.toggleClass(cl);
			});
		});
	}
}
